// @flow
import React from 'react';
import NuxInterest from 'app/common/react/components/growth/activation/NuxInterest/NuxInterest';
import {
  type InterestObj,
  type CategoryObj,
} from 'app/common/react/components/growth/activation/NuxConst/NuxConst';
import { Box, Text } from 'gestalt';

type OwnProps = {|
  categorized?: boolean,
  categories: Array<CategoryObj>,
  categoryProps?: {
    categories?: Array<CategoryObj>,
    handleInterestClickFn?: (InterestObj) => () => void,
  },
  handleBottomScroll: (isBottom: boolean) => void,
  handleInterestClickFn: (InterestObj) => () => void,
  interests: Array<InterestObj>,
  interestFlipMessages: { [key: string]: string },
  interestsToFlip: Set<string>,
  showTableOfContents?: boolean,
|};

type Props = {|
  ...OwnProps,
|};

const RenuxCategoryPicker = (props: Props) => {
  const { categories, handleInterestClickFn, interestFlipMessages, interestsToFlip } = props;

  return (
    <Box display="flex" direction="row" justifyContent="between" wrap paddingX={8}>
      {categories.map((category: CategoryObj) => (
        <Box key={category.title} paddingY={1}>
          <Text size="xl" bold>
            {category.title}
          </Text>
          <Box direction="row" display="flex" justifyContent="between">
            {category.interests.map((interest: InterestObj) => {
              const interestProps = {
                clickHandler: handleInterestClickFn(interest),
                interest,
                key: interest.id,
                isSelected: interest.is_followed,
                isCategorized: true,
                flipText: interestFlipMessages[interest.id] || '',
                shouldFlip: interestsToFlip.has(interest.id),
              };
              return (
                <Box key={interest.id} padding={1}>
                  <NuxInterest {...interestProps} />
                </Box>
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default RenuxCategoryPicker;
